<template>
    <base-spinner :open="isloading"></base-spinner>
    <base-message
    v-if="!isloading"
    :servermessages="servermessages"
    ></base-message>
    <div class="site__body" v-if="content != '' && !isloading">
        <div class="block-space block-space--layout--spaceship-ledge-height">&nbsp;</div>
        <div class="block faq">
            <div class="container container--max--xl">
                <div class="faq__header">
                    <h1 class="faq__header-title">{{header}}</h1>
                </div>
                <div class="document__content card">
                    <div class="document__content" v-html="content"></div>
                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--before-footer"></div>
    </div>
    <div class="text-center mt-4 mb-4" v-if="content === '' && !isloading">Content Unavailable.</div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    data() {
        return {
            header: '',
            content: '',
            isloading: false,
            error: '',
            servermessages: []
        }
    },
    methods: {
        getContent() {
            this.isloading = true;
            this.content = '';
            this.servermessages = [];
            const return_policy_uri = this.$store.getters['api/return_policy_uri'];
            axiosvl.post(return_policy_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "LW3SFID": {
                                value: this.$store.getters.storefront,
                            },
                            "LW3PAGSDC": {
                                "value": this.$route.params.page
                            },
                            "LW3PAGLSD": {
                                "value": this.$route.params.location
                            }
                        }
                    }
                }
            )
            .then((response) => {
                this.isloading = false;
                const fields = response.data.webroutine.fields;

                if (fields.LW3RETCOD.value != 'OK'){
                    this.$router.push('/404');
                    return
                }
                
                this.content = fields.LW3CNTSTR.value;
                this.header = fields.LW3CNTLDC.value;

                const messages = [];
                const wrmessages = response.data.webroutine.messages;

                if (wrmessages != undefined) {
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                    this.servermessages = messages;
                }

            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        }
    },
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        
    },
    mounted() {
        let tmout = 500;
        if (this.$store.getters.storefront == ''){
            tmout = 2000;
        }

        setTimeout(() => {
            this.getContent();    
        }, tmout);
    }

}
</script>